import { Component } from "@angular/core";


@Component({
    selector: 'flex-row',
    standalone: true,
    imports: [],
    template: `
        <div class="flex-row">
            <div class="left">
                <ng-content select="[left]"></ng-content> 
            </div>
            <div class="center">
                <ng-content select="[center]"></ng-content> 
            </div>
            <div class="right">
                <ng-content select="[right]"></ng-content> 
            </div>
        </div> 
    `,
})
export class FlexRowContainer{
 
}